/* eslint-disable default-case */
'use strict';

angular.module('app', [
  'ui.bootstrap',
  'ngRoute',
  'ngFileUpload',
  'ui.select',
  'ngSanitize',
  'LocalStorageModule',
  'gettext'
]);

angular.module('app')
  .run(function ($window, $rootScope, $location, $route, info, localStorageCheckService, gettextCatalog, selectedLanguage, ) {
    $rootScope.user = false;

    if (selectedLanguage === 'ach') {
      gettextCatalog.setCurrentLanguage('ach_UG');
    } else {
      gettextCatalog.setCurrentLanguage(selectedLanguage + '_' + selectedLanguage.toLocaleUpperCase());
    }

    var translationFileName = '';

    switch (selectedLanguage) {
    case 'de':
      translationFileName = 'angular-de.json';
      break;
    case 'fr':
      translationFileName = 'angular-fr.json';
      break;
    case 'it':
      translationFileName = 'angular-it.json';
      break;
    case 'es':
      translationFileName = 'angular-es.json';
      break;
    case 'nl':
      translationFileName = 'angular-nl.json';
      break;
    case 'ach':
      translationFileName = 'angular-ach.json';
      break;
    }

    if (selectedLanguage !== 'en') {
      gettextCatalog.loadRemote('/translations/' + translationFileName).then(function () {
        $rootScope.translationsUploaded = true;
      });
    }
    // check if localstorase is supported
    localStorageCheckService.check();

    var original = $location.path;
    $location.pathWithoutReload = function (path, reload) {
      if (reload === false) {
        var lastRoute = $route.current,
          un = $rootScope.$on('$locationChangeStart', function (event) {
            window.history.replaceState({}, path, path);
            event.preventDefault();

            $route.current = lastRoute;
            un();
          });
      }
      return original.apply($location, [path]);
    };
  })
  .config(function ($locationProvider, localStorageServiceProvider, $httpProvider) {
    localStorageServiceProvider
      .setPrefix('diviac')
      .setStorageType('sessionStorage')
      .setNotify(true, true);

    $locationProvider.html5Mode({
      enabled: true,
      requireBase: false,
    });

    $httpProvider.interceptors.push('authHttpResponseInterceptor');
    $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
  });
